<div class="modal-body h-full">
  <header class="modal-header">
    <div class="flex items-baseline mat-dialog-title">
      <h2 class="!text-2xl modal-headline" i18n>{{ data && data.callFrom === 'dashboard' ? 'TAGS IN DASHBOARD' : 'Tags' }}</h2>
      <div class="ml-auto">
        <button mat-icon-button mat-dialog-close class="button-close">
          <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
          <span class="sr-only" i18n>Close</span>
        </button>
      </div>
    </div>
  </header>
  <mat-dialog-content class="w-full h-[345px]">
    <div [ngClass]="{ 'ml-7': data && data.callFrom !== 'dashboard' }">
      <div class="inline-block w-1/2" [ngClass]="{ 'w-full': data.callFrom !== 'dashboard' }">
        <sp-search-field
          class="max-w-[500px]"
          [searchText]="searchText"
          [maxWidth]="'500px'"
          (keyUpInput)="searchTextChanged($event)"
          (clearInput)="clearSearch()"
          [placeholder]="searchPlaceholder"
        ></sp-search-field>
      </div>
      <div *ngIf="data && data.callFrom === 'dashboard'" class="inline-block w-1/2 align-top">
        <div class="align-middle py-[10px] px-8">
          <mat-checkbox (change)="selectDefaultKeywords($event)" [checked]="selectDefaultKeywordFlag" class="text-sm"> </mat-checkbox>
          <span class="text-gray-600 inline-block align-text-top" i18n> Select 20 most popular tags </span>
        </div>
      </div>
    </div>
    <thehubz-tags-chip
      [tagsObs]="tagsObs"
      [tagData]="data"
      [searchText]="searchText"
      [selectDefaultKeywordFlag]="selectDefaultKeywordFlag"
      [paginator]="paginatorObj"
      (paginatorEvent)="paginatorAssignment($event)"
      (searchedTagsEvent)="searchedTags($event)"
    ></thehubz-tags-chip>
    <div *ngIf="showEmptyState" class="ml-7 overflow-hidden">
      <sp-blank-page pageType="tags"></sp-blank-page>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="modal-footer flex justify-end sticky bottom-0">
      <mat-paginator [pageSizeOptions]="[paginatorObj.pageSize]" [hidePageSize]="true" (page)="onPaginateChange($event)"></mat-paginator>
      <!-- Set of buttons showing on filter menu -->
      <div [matTooltip]="!selectedTagsList.length ? 'Click any tag to select' : ''" [matTooltipDisabled]="!!selectedTagsList.length">
        <button mat-flat-button class="button-primary" (click)="applyTags()" [disabled]="disableApply">
          <mat-icon class="material-icons-outlined">check</mat-icon>
          <span class="px-2 font-bold" i18n>Apply</span>
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
